<template>
  <svg
    width="7"
    height="14"
    viewBox="0 0 7 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    @click="$emit('click')"
  >
    <path
      d="M6.74789 7.0098C6.7483 7.21806 6.67568 7.41988 6.54264 7.58023L2.08066 12.928C1.92918 13.11 1.71152 13.2245 1.47555 13.2462C1.23957 13.268 1.00462 13.1952 0.82238 13.0439C0.640138 12.8926 0.525533 12.6752 0.503776 12.4395C0.48202 12.2038 0.554894 11.9692 0.706368 11.7872L4.7043 7.0098L0.849152 2.23245C0.775024 2.14128 0.719668 2.03638 0.686264 1.92377C0.65286 1.81117 0.642067 1.69308 0.654507 1.57629C0.666946 1.45951 0.702371 1.34633 0.758747 1.24326C0.815123 1.1402 0.891338 1.04927 0.983011 0.97572C1.07477 0.894096 1.18242 0.832276 1.29921 0.794135C1.416 0.755995 1.53942 0.742355 1.66173 0.754069C1.78405 0.765784 1.90262 0.8026 2.01003 0.862212C2.11743 0.921825 2.21135 1.00295 2.28591 1.1005L6.59618 6.44829C6.70819 6.61325 6.76161 6.81095 6.74789 7.0098Z"
      fill="black"
    />
  </svg>
</template>

<script>
export default {
  name: 'BlackArrowRight14'
};
</script>

<style scoped>

</style>